import view from "../../views/home.js";
import KTAPI from "../api/index.api.js";
import { KTLang } from "../lang/lang.js";
import { _handler, CustomCarousel, getEloLevel } from "../classes/index.classes.js";
import { router } from "../router/index.routes.js";
import { msgDialog, welcomeDialog } from "./offscreen.controller.js";

const removeHtmlTags = str => str.replace(/<[^>]*>|&lt;[^&gt;]*&gt;/g, '');
const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);

const bgColors = {announcement: 'light-primary', new: 'light-info', event: 'light-danger', update: 'light-success'};

var loading = false;

let cl = {
    render: (info) => {
        return info ? '' : view;
    },
    after_render: async (info) => {
        console.log("Home controller", info);
        renderNewsWidget();
        getBestPlayers();
    },
    root: false, 
    rerender: true,
    where: '#kt_content'
};

async function renderNewsWidget(){
    /*let res = await KTAPI.getNews({page: 1, limit: 5});
    if(res.message == 'done'){
        initNewsCarousel(res.news.docs);
    }*/
   KTAPI.getNews({page: 1, limit: 5}).then(res => {
        if(res.message == 'done'){
            initNewsCarousel(res.news.docs);
        }
    }).catch(err => {
        console.error(err);
    });
}

let newsCarousel = null;
async function initNewsCarousel(data) {
    //if(newsCarousel) newsCarousel.destroy();
    /*newsCarousel = new CustomCarousel(".widget-news-carousel", {
        interval: 7500, 
        ride: true,
        pause: 'hover',
        wrap: true,
        keyboard: true,
        indicators: true,
        controls: false
    });

    data.forEach(item => {
        Object.keys(item.translations).forEach(key => {
            newsCarousel.addItem(`
                <a data-navigo href="news/${item.slug}" class="w-100 rounded">
                    <img src="${item.translations[key].image}" class="d-block w-100" alt="">
                </a>
                `, `lang="${key}"`);
        });
    });

    
    console.log("Carousel items", newsCarousel.items);
    const lng = KTLang.getLang();

    //newsCarousel.hideItemsBySelector(`a[lang]:not([lang="${lng}"])`);
    newsCarousel.hideItemsBySelector(`[lang="en"]`);

    //newsCarousel.hideItem(0);

    newsCarousel.start();*/

    newsCarousel = new CustomCarousel('.widget-news-carousel', {
        id: 'myCustomCarousel',
        interval: 5000,
        ride: 'carousel',
        pause: 'hover',
        wrap: true,
        keyboard: true,        
        indicators: true,
        controls: false,
        customIndicatorTemplate: function(index) {            
            return `<li class="ms-1" data-bs-target="#myCustomCarousel" data-bs-slide-to="${index}"></li>`;
          },
        eventHandlers: {
          'slide.bs.carousel': function(e) {
            //console.log('Slide event triggered:', e);
          },
          'slid.bs.carousel': function(e) {
            //console.log('Slid event triggered:', e);
          }
        }
      });

    const lng = KTLang.getLang();
    data.forEach(item => {
    Object.keys(item.translations).forEach(key => {
        if(key === lng)
        {
            newsCarousel.addItem(`
            <a data-navigo href="news/${item.slug}" class="w-100 rounded">
                <img src="${item.translations[key].image}" class="d-block w-100" alt="">
            </a>
            `, {'lang': key});
        }

        });
    });
    
    newsCarousel.start();
    
    //newsCarousel.hideItem(`.carousel-item[lang]:not([lang="${lng}"])`);
    
}

async function getBestPlayers(){
    KTAPI.getBestPlayersEachCountry().then(res => {        
        renderBestPlayers(res);        
    }).catch(err => {
        console.error(err);
    });
}

function renderBestPlayers(players){
    let html = '';
    players.forEach(player => {
        let nick = $(`<div>${player.user.nickname}</div>`).text();
        let level = getEloLevel(player.rating, player.rd);
        html += `
            <div class="col">                
                <div class="card bg-zblack bg-gradient">                                
                    <div class="card-body d-flex flex-center flex-column py-8 px-5">
                        <div class="d-flex justify-content-center align-items-center fs-6 fw-bold text-gray-900 gap-2 text-uppercase mb-6">
                            <img class="mb-1" src="assets/media/flags/${player.flag.toLowerCase()}.gif" style="vertical-align: middle;"><span class="lh-0 teko-header text-uppercase fs-3">${player.country}</span>
                        </div>
                        <div class="symbol symbol-45px mb-4 ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${player.user.steamid}">
                            <img src="${player.user.avatar}" alt="image">
                            <div class="${player.user.connected ? "bg-success" : "bg-gray-400"} position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-body h-15px w-15px ms-n3 mt-n3"></div>
                        </div>                                            
                        
                        <a href="user/${player.user.communityid}" data-navigo="" class="fs-6 text-gray-800 fw-bolder opacity-75-hover mb-0">${nick}</a>
                        
                        <div class="fw-semibold text-gray-500 mb-6"><a href="https://steamcommunity.com/profiles/${player.user.communityid}/" target="_blank" class="text-gray-500 text-hover-info">${player.steamid}</a></div>
                          
                        <div class="d-flex flex-center flex-nowrap">
                            <div class="rounded py-2 px-4 mx-2 bg-gray-100">
                                <div class="d-flex align-items-center justify-content-center">
                                    <div class="symbol symbol-45px rounded overflow-hidden">
                                        <span class="symbol-label bg-transparent">
                                            <img src="assets/media/ranks/rank_${level.level}.png" class="h-100 align-self-center" alt="">
                                        </span>
                                    </div>                                                
                                </div>
                            </div>
                            
                            <div class="rounded min-w-90px py-3 px-4 mx-2 text-center bg-gray-100">
                                <div class="fs-6 fw-bold text-gray-800">${player.rating}</div>
                                <div class="fw-semibold text-gray-400">Rating</div>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        `;
    });

    $('.widget-best-players').html(html);
}



_handler.on('lang-changed', async (lng) =>{
    if(newsCarousel){
        newsCarousel._destroyCarousel();        
    }
    await renderNewsWidget();
});


$(document).ready(function(){
    
});

export default cl;